exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload_div[data-v-2e9c01a0] {\n  line-height: 0.5rem;\n  text-align: center;\n  background-color: #fbf3f3;\n  margin-top: 0.026042rem;\n}\n.upload_div > span[data-v-2e9c01a0] {\n  display: inline-block;\n  min-width: 0.520833rem;\n  text-align: right;\n}\n.uploadBtn[data-v-2e9c01a0] {\n  display: inline;\n}\n.upload_div p[data-v-2e9c01a0] {\n  display: inline;\n}\n.upload_div .remove[data-v-2e9c01a0] {\n  display: inline;\n  cursor: pointer;\n  color: #c39696;\n}\n.upload_div .remove[data-v-2e9c01a0]:hover {\n  color: #1384e5;\n  text-decoration: underline;\n}", ""]);

// exports
